module.exports = __webpack_public_path__ + "img/foot-bg.4f6bdf72.png";